export default function TrophyIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2319 18.1429V14.1875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.59394 18.1406H12.8678C13.5671 18.1406 14.2378 18.4184 14.7323 18.913C15.2268 19.4075 15.5047 20.0782 15.5047 20.7775H4.95703C4.95703 20.0782 5.23485 19.4075 5.72936 18.913C6.22388 18.4184 6.89459 18.1406 7.59394 18.1406Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5015 2.32031H19.4568V6.27567C19.4568 7.3247 19.0401 8.33076 18.2983 9.07253C17.5566 9.81431 16.5505 10.231 15.5015 10.231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.95536 2.32031H1V6.27567C1 7.3247 1.41672 8.33076 2.1585 9.07253C2.90027 9.81431 3.90633 10.231 4.95536 10.231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.95703 1H15.5047V8.91072C15.5047 10.3094 14.949 11.6508 13.96 12.6399C12.971 13.6289 11.6295 14.1845 10.2308 14.1845C8.83214 14.1845 7.49073 13.6289 6.5017 12.6399C5.51266 11.6508 4.95703 10.3094 4.95703 8.91072V1Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
